import React from "react";
import {Stack, Button} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const styles = {
    buttonContainer: {
        margin: '0.5rem',
        marginTop: '0rem',
    },
    refreshIcon: {
        minWidth: 'auto',
        width: '2.3rem',
    }
};

export default function HierarchyActionButtons({onRefresh, onExpandAll, onCollapseAll}) {
    return (
      <Stack spacing={2} direction="row" sx={styles.buttonContainer}>
          <Button variant="contained" onClick={onRefresh} sx={styles.refreshIcon}><RefreshIcon/></Button>
          <Button variant="contained" onClick={onExpandAll}>Expand All</Button>
          <Button variant="contained" onClick={onCollapseAll}>Collapse All</Button>
      </Stack>
    );
}